module.exports = __webpack_public_path__ + "img/business-management.ccc35aa7.jpg";